import Route from '@ember/routing/route';
import type { ModelFrom } from 'frontend-payments/utils/routes';

export type Model = ModelFrom<LoginRoute>;

export default class LoginRoute extends Route {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    return {};
  }
}
